import { useNavigate } from 'react-router-dom';
import "../style/Global.css";
import "../style/Home.css"

function Home({ isAuth }) {

    let navigate = useNavigate();

    const redirect = () => {
        if (!isAuth) {
            navigate('/Login');
        } else {
            const role = localStorage.getItem("role");
            if (role === "Teacher") {
                navigate('/CreateQuestionnaire');
            } else {
                navigate('/StudentDashboard');
            }
        }
    }

    return (
        <div className="homePage">
            <div className="leftSide">
                <h1>Making groups the simpler way</h1>
                <p>Designed for seamless collaboration, our platform allows you to create, distribute, and analyse questionnaires with ease.</p>
                <button className="get-started-btn" onClick={redirect}>
                    Get Started
                </button>
            </div>
            <div className="rightSide">
                <img src="/Images/Image1.png" alt="Home" />
            </div>
        </div>
    );
}

export default Home;